export const siteConfig = {
  siteUrl: 'https://apexconsulting.co.uk',
  cmsUrl: 'https://cms.apexconsulting.co.uk',
  cmsApiBaseUrl: 'https://cms.apexconsulting.co.uk/wp-json/wp/v2',
  cmsApiAuthUrl: 'https://cms.apexconsulting.co.uk/wp-json/jwt-auth/v1/token',
};

export default siteConfig;
